import { Document, Page, View, Text, StyleSheet, Font } from '@react-pdf/renderer';

const colors = {
  black: '#050505',
  card: '#121212',
  gold: '#D4AF37',
  cream: '#F5F5DC',
  muted: '#A1A1AA',
  white: '#FFFFFF',
  darkBorder: '#2A2A2A',
  darkGold: '#8B7320',
};

const styles = StyleSheet.create({
  page: {
    backgroundColor: colors.black,
    padding: 40,
    fontFamily: 'Helvetica',
    color: colors.cream,
  },
  coverPage: {
    backgroundColor: colors.black,
    padding: 0,
    fontFamily: 'Helvetica',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  coverBorder: {
    border: `3px solid ${colors.gold}`,
    margin: 30,
    padding: 50,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  coverTitle: {
    fontSize: 36,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    marginBottom: 12,
    letterSpacing: 2,
  },
  coverSubtitle: {
    fontSize: 16,
    color: colors.cream,
    textAlign: 'center',
    marginBottom: 30,
    letterSpacing: 1,
  },
  coverLine: {
    width: 120,
    height: 2,
    backgroundColor: colors.gold,
    marginBottom: 30,
  },
  coverSchool: {
    fontSize: 22,
    color: colors.cream,
    fontFamily: 'Helvetica-Bold',
    textAlign: 'center',
    marginBottom: 8,
  },
  coverTagline: {
    fontSize: 11,
    color: colors.muted,
    textAlign: 'center',
    letterSpacing: 3,
  },
  coverFooter: {
    fontSize: 9,
    color: colors.muted,
    textAlign: 'center',
    marginTop: 40,
  },
  sectionHeader: {
    fontSize: 22,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 16,
    paddingBottom: 8,
    borderBottom: `2px solid ${colors.gold}`,
  },
  subsectionHeader: {
    fontSize: 16,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 8,
    marginTop: 16,
  },
  classroomHeader: {
    fontSize: 18,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
  },
  classroomTagline: {
    fontSize: 11,
    color: colors.muted,
    fontStyle: 'italic',
    marginBottom: 8,
  },
  paragraph: {
    fontSize: 10,
    color: colors.cream,
    lineHeight: 1.6,
    marginBottom: 8,
  },
  bulletItem: {
    fontSize: 10,
    color: colors.cream,
    lineHeight: 1.5,
    marginBottom: 3,
    paddingLeft: 12,
  },
  bulletGold: {
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
  },
  cardBox: {
    backgroundColor: colors.card,
    borderRadius: 6,
    padding: 12,
    marginBottom: 10,
    border: `1px solid ${colors.darkBorder}`,
  },
  statusBox: {
    backgroundColor: colors.card,
    borderRadius: 6,
    padding: 10,
    marginBottom: 6,
    borderLeft: `3px solid ${colors.gold}`,
  },
  statusTitle: {
    fontSize: 11,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 3,
  },
  statusDesc: {
    fontSize: 9,
    color: colors.cream,
    lineHeight: 1.5,
  },
  classCard: {
    backgroundColor: colors.card,
    borderRadius: 4,
    padding: 8,
    marginBottom: 6,
    borderLeft: `2px solid ${colors.darkGold}`,
  },
  className: {
    fontSize: 10,
    color: colors.cream,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 2,
  },
  classDesc: {
    fontSize: 8,
    color: colors.muted,
    lineHeight: 1.4,
    marginBottom: 3,
  },
  tagRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 2,
  },
  tag: {
    fontSize: 7,
    color: colors.gold,
    backgroundColor: '#1a1a0a',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 3,
    border: `1px solid ${colors.darkGold}`,
  },
  scriptBox: {
    backgroundColor: '#0a0a0a',
    borderRadius: 6,
    padding: 12,
    marginBottom: 8,
    borderLeft: `3px solid ${colors.gold}`,
  },
  scriptLabel: {
    fontSize: 9,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 4,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  scriptText: {
    fontSize: 10,
    color: colors.cream,
    lineHeight: 1.6,
    fontStyle: 'italic',
  },
  checklistItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 4,
  },
  checkBox: {
    width: 10,
    height: 10,
    border: `1px solid ${colors.gold}`,
    borderRadius: 2,
    marginRight: 8,
    marginTop: 2,
  },
  checkText: {
    fontSize: 10,
    color: colors.cream,
    flex: 1,
    lineHeight: 1.5,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 8,
    bottom: 20,
    right: 40,
    color: colors.muted,
  },
  pageFooter: {
    position: 'absolute',
    fontSize: 8,
    bottom: 20,
    left: 40,
    color: colors.darkGold,
  },
  twoCol: {
    flexDirection: 'row',
    gap: 12,
  },
  col: {
    flex: 1,
  },
  objectionQ: {
    fontSize: 10,
    color: colors.gold,
    fontFamily: 'Helvetica-Bold',
    marginBottom: 3,
  },
  objectionA: {
    fontSize: 10,
    color: colors.cream,
    lineHeight: 1.6,
    marginBottom: 10,
    paddingLeft: 8,
  },
  talkingPoint: {
    fontSize: 9,
    color: colors.cream,
    lineHeight: 1.5,
    marginBottom: 3,
    paddingLeft: 10,
    borderLeft: `1px solid ${colors.darkGold}`,
  },
});

const classroomLiterature = {
  'music-gym': {
    tagline: "Build Your Musical Muscles",
    overview: "Think of this as your fitness training for piano. Just like how athletes have specific workouts for strength, speed, and endurance, Music Gym provides systematic exercises that build your technical foundation. This isn't about playing songs\u2014it's about developing the physical and mental capabilities that make everything else easier.",
    whoIsThisFor: [
      "Students who feel their fingers can't keep up with what they hear in their head",
      "Anyone who struggles with fast passages or complex rhythms",
      "Musicians who want to build stamina for longer practice sessions",
      "Those transitioning from casual playing to serious study"
    ],
    keyBenefits: [
      "Develop finger independence so each hand can do its own thing",
      "Build speed without sacrificing accuracy",
      "Create muscle memory that makes difficult passages automatic",
      "Prevent injury through proper technique"
    ],
    talkingPoints: [
      "Ask: 'Do you ever feel like your hands can't keep up with the music you want to play?'",
      "Explain: '3D Training covers three dimensions\u2014technical accuracy, speed development, and musical endurance'",
      "For jazz students: 'JZ Etudes gives you the vocabulary that makes improvisation natural, not forced'",
      "Analogy: 'Athletes don't just play games\u2014they train. This is your training ground.'"
    ]
  },
  'music-factory': {
    tagline: "Where Music Gets Made",
    overview: "Music Factory is where creativity meets craft. This classroom takes you beyond playing notes to actually understanding, creating, and producing music. From transcribing your favorite songs by ear to arranging for different ensembles to recording your own tracks\u2014this is where you become a complete musician, not just a pianist.",
    whoIsThisFor: [
      "Musicians who want to figure out songs without sheet music",
      "Those interested in music production and arrangement",
      "Church musicians who need to create arrangements on the fly",
      "Anyone who wants to understand why their favorite music sounds the way it does"
    ],
    keyBenefits: [
      "Learn to transcribe any song by ear\u2014no more depending on sheet music",
      "Understand how to arrange music for different settings",
      "Get hands-on with music production technology",
      "Develop the skills to create responsive, in-the-moment music"
    ],
    talkingPoints: [
      "Ask: 'Have you ever wanted to just hear a song and be able to play it?'",
      "Explain: 'Transcription is like learning a new language\u2014once you can do it, you can learn anything'",
      "For producers: 'Production class bridges the gap between playing and recording'",
      "For worship leaders: 'Church Hymns & Orchestration helps you lead with confidence'"
    ]
  },
  'modular-piano': {
    tagline: "Your Piano, Your Way",
    overview: "Modular Piano breaks down piano playing into specific, learnable skills. Instead of following a rigid curriculum, you pick the modules that matter to you. Want to accompany yourself while singing? There's a module for that. Want to add fills and ornaments like the pros? We've got you covered. This is customized piano education.",
    whoIsThisFor: [
      "Singer-songwriters who want to accompany themselves",
      "Keyboardists who play in bands or worship teams",
      "Those who want to learn specific techniques without a full course",
      "Players who want to add professional polish to their playing"
    ],
    keyBenefits: [
      "Learn exactly what you need, skip what you don't",
      "Master different keyboard sounds\u2014EP, organ, synth, clav",
      "Add professional ornaments, fills, and dynamics",
      "Build independence between hands for fuller sound"
    ],
    talkingPoints: [
      "Ask: 'What's the one thing you wish you could do better on piano?'",
      "Explain: 'Each module is self-contained\u2014you can take just what you need'",
      "For singers: 'Sing & Play teaches you to simplify accompaniment while you perform'",
      "For band players: 'Keyboard Styles covers EP, clav, organ\u2014sounds that define modern music'"
    ]
  },
  'theory-ear-training': {
    tagline: "Understand What You Play",
    overview: "Theory & Ear Training is your musicianship foundation. This isn't dry textbook theory\u2014it's practical knowledge that changes how you hear and create music. Learn to read chord charts, recognize intervals by ear, understand why certain progressions work, and communicate with other musicians in their language.",
    whoIsThisFor: [
      "Self-taught musicians who want to fill in the gaps",
      "Those who can play but don't understand what they're playing",
      "Musicians who want to jam confidently with others",
      "Anyone preparing for music exams or professional work"
    ],
    keyBenefits: [
      "Hear a note or chord and know what it is instantly",
      "Read jazz chord charts and lead sheets",
      "Understand harmonic progressions and substitutions",
      "Communicate effectively with other musicians"
    ],
    talkingPoints: [
      "Ask: 'Can you hear a melody and know what notes they are?'",
      "Explain: 'Ear training is like learning to see\u2014once you can hear it, music opens up'",
      "For jammers: 'Jazz Chord Charts class lets you walk into any session and play'",
      "Reality check: 'Most professional musicians have strong theory\u2014it's the language of music'"
    ]
  },
  'seasonal-genre': {
    tagline: "Play What the World Plays",
    overview: "Seasonal & Genre Based is your ticket to being the musician everyone wants at gatherings. From Christmas carols to Bollywood hits, from blues to Latin rhythms\u2014this classroom keeps you relevant and versatile. Learn the authentic techniques that make each genre sound right, not like a generic cover.",
    whoIsThisFor: [
      "Musicians who play for family gatherings and events",
      "Those who want to expand beyond one style",
      "Players who want to stay current with trending music",
      "Anyone interested in world music and diverse styles"
    ],
    keyBenefits: [
      "Be ready for any occasion\u2014holidays, parties, cultural events",
      "Learn authentic techniques for each genre",
      "Stay current with trending songs and viral hits",
      "Develop genuine versatility, not surface-level familiarity"
    ],
    talkingPoints: [
      "Ask: 'What kind of music do people usually request from you?'",
      "Explain: 'Each genre has its own feel\u2014we teach you the authentic techniques'",
      "For Indian students: 'Bollywood and Coke Studio modules are very popular'",
      "Seasonal tip: 'Christmas module is perfect for December gigs and family gatherings'"
    ]
  },
  'new-offerings': {
    tagline: "Learn Together, Grow Together",
    overview: "New Offerings is where individual practice meets group experience. These aren't traditional lessons\u2014they're collaborative sessions where you play with other musicians, perform in workshops, and learn real-world skills that only come from doing. This is the closest thing to being in a band while you're still learning.",
    whoIsThisFor: [
      "Musicians who practice alone but want to play with others",
      "Those preparing for live performance",
      "Anyone who wants to develop their musical ear through collaboration",
      "Students interested in the business side of music"
    ],
    keyBenefits: [
      "Experience playing with other musicians in real-time",
      "Get performance experience in a supportive environment",
      "Learn the practical skills working musicians need",
      "Build confidence through group activities"
    ],
    talkingPoints: [
      "Ask: 'Have you ever played music with other people?'",
      "Explain: 'Jam sessions teach you to listen and respond\u2014skills you can't learn alone'",
      "For aspiring pros: 'Working Musician Skills covers performing, recording, and teaching'",
      "Unique offering: 'Riff with Jason Zac is mentorship with a professional artist'"
    ]
  },
  'foundation-lessons': {
    tagline: "Build It Right From The Start",
    overview: "Foundation Lessons is where basics are done right. Whether you're starting fresh or rebuilding shaky fundamentals, this classroom ensures you have the proper technique, reading ability, and musical understanding that everything else builds on. Skip this at your peril\u2014bad habits are hard to break later.",
    whoIsThisFor: [
      "Complete beginners starting their musical journey",
      "Self-taught players who developed bad habits",
      "Those returning to piano after a long break",
      "Anyone who feels their basics aren't solid"
    ],
    keyBenefits: [
      "Establish correct technique from day one",
      "Learn to read music properly",
      "Understand fundamental theory concepts",
      "Build a foundation that supports advanced study"
    ],
    talkingPoints: [
      "Ask: 'How did you first learn piano? Did you have formal training?'",
      "Explain: 'Proper foundation prevents injuries and makes advanced stuff easier'",
      "For returners: 'Think of this as a reset\u2014we'll identify and fix any bad habits'",
      "Important: 'Everyone thinks they can skip basics. The pros never did.'"
    ]
  }
};

const classroomData = [
  {
    id: "music-gym",
    name: "Music Gym",
    description: "Intensive training modules for building musical strength and dexterity through systematic exercises and etudes.",
    classes: [
      { name: "Music Gym - 3D Training", description: "Comprehensive training covering all dimensions of musical fitness - technique, speed, and endurance.", musical_benefits: ["Enhanced finger strength", "Improved coordination", "Better muscle memory"], usps: ["Structured workout approach", "Measurable progress", "Prevents injury"] },
      { name: "JZ Etudes & Motifs", description: "Study etudes and recurring musical motifs with Jason Zac to develop improvisational vocabulary across multiple genres.", musical_benefits: ["Musical vocabulary expansion", "Stylistic fluency", "Improvisational confidence"], usps: ["Learn from Jason Zac", "Real-world application", "Artist-inspired content"] },
      { name: "JZ Riff Dive", description: "Deep dive into riffs and licks with Jason Zac, learning from great pianists across various styles.", musical_benefits: ["Authentic phrasing", "Creative inspiration", "Performance repertoire"], usps: ["Learn from the masters with Jason Zac", "Build your lick library", "Immediate application"] }
    ]
  },
  {
    id: "music-factory",
    name: "Music Factory",
    description: "Creative production hub where students learn to create, arrange, and produce music.",
    classes: [
      { name: "Transcription", description: "Learn to transcribe music by ear - a crucial skill for any serious musician.", musical_benefits: ["Ear development", "Musical memory", "Analytical skills"], usps: ["Essential skill for pros", "Improves all areas of musicianship", "Independence from sheet music"] },
      { name: "Artist/Song Appreciation", description: "Deep study of influential artists and their signature songs.", musical_benefits: ["Stylistic awareness", "Musical vocabulary", "Appreciation depth"], usps: ["Learn from legends", "Understand music history", "Develop your taste"] },
      { name: "Production/Arrangement/Technology", description: "Modern music production using DAWs, virtual instruments, and recording technology.", musical_benefits: ["Production skills", "Arrangement ability", "Technical fluency"], usps: ["Industry-standard tools", "Complete songs", "Portfolio building"] },
      { name: "Improvisation", description: "Freedom to create music spontaneously with frameworks and techniques.", musical_benefits: ["Creative freedom", "Quick thinking", "Musical conversation"], usps: ["Express yourself", "Never be stuck", "Jam with anyone"] },
      { name: "Music from Different Cultures", description: "Explore musical traditions from around the world.", musical_benefits: ["Global perspective", "Rhythmic diversity", "Cultural appreciation"], usps: ["Unique repertoire", "Stand out", "Broaden horizons"] },
      { name: "Lick Library", description: "Build your personal library of musical phrases and patterns.", musical_benefits: ["Ready vocabulary", "Quick recall", "Stylistic versatility"], usps: ["Always have ideas", "Professional resource", "Continuous growth"] },
      { name: "Church Hymns & Orchestration Study", description: "Study of church music and orchestration for different ensembles.", musical_benefits: ["Worship leading", "Arrangement skills", "Harmonic richness"], usps: ["Serve your community", "Full arrangements", "Leadership skills"] },
      { name: "Real-time Responsive Playing", description: "Learn to respond musically in real-time for accompanying and jamming.", musical_benefits: ["Quick adaptation", "Musical intuition", "Collaborative skills"], usps: ["Be the go-to musician", "Never freeze", "Musical conversations"] },
      { name: "Study of Great Pianists & Composers", description: "In-depth study of legendary pianists and composers.", musical_benefits: ["Inspiration", "Technique models", "Historical knowledge"], usps: ["Learn from the best", "Rich context", "Aspiration targets"] }
    ]
  },
  {
    id: "modular-piano",
    name: "Modular Piano",
    description: "Flexible, modular approach to piano technique covering all essential skills.",
    classes: [
      { name: "Artist/Song Based", description: "Learn piano through the songs you love.", musical_benefits: ["Motivation boost", "Practical skills", "Repertoire building"], usps: ["Learn what you love", "Immediate satisfaction", "Relevant skills"] },
      { name: "Finger Exercises", description: "Systematic finger training for strength and dexterity.", musical_benefits: ["Physical capability", "Speed potential", "Endurance"], usps: ["Solid foundation", "Injury prevention", "Measurable progress"] },
      { name: "Chord Practice - Voicing & Inversions", description: "Master chord voicings and inversions.", musical_benefits: ["Harmonic fluency", "Smooth transitions", "Professional sound"], usps: ["Sound like a pro", "Versatility", "Compositional tool"] },
      { name: "Hand Independence", description: "Develop the ability to play different patterns with each hand.", musical_benefits: ["Coordination", "Polyphonic ability", "Musical freedom"], usps: ["Unlocks advanced playing", "Self-sufficient", "One-person band"] },
      { name: "Sight Reading", description: "Develop fluent sight reading across multiple styles.", musical_benefits: ["Musical literacy", "Quick learning", "Versatility"], usps: ["Learn songs faster", "Session-ready", "Professional skill"] },
      { name: "Accompaniment - Sing & Play", description: "Learn to accompany yourself or others while singing.", musical_benefits: ["Self-sufficiency", "Performance confidence", "Supporting skills"], usps: ["Complete performer", "Gig-ready", "Worship leading"] },
      { name: "Grooving & Piano Percussion", description: "Turn your piano into a rhythmic instrument.", musical_benefits: ["Rhythmic strength", "Band awareness", "Energy control"], usps: ["Be the rhythm section", "Energy and drive", "Unique sound"] },
      { name: "Keyboard Playing Styles", description: "Master different keyboard sounds - EP, Clav, Organ, Synth.", musical_benefits: ["Tonal versatility", "Style authenticity", "Modern relevance"], usps: ["Multiple instruments", "Session versatility", "Modern sound"] },
      { name: "Piano Ornaments & Dynamics", description: "Add professional polish with ornaments and dynamic control.", musical_benefits: ["Professional polish", "Expressive range", "Signature sound"], usps: ["Sound sophisticated", "Personal flair", "Pro touches"] },
      { name: "Creating & Practicing Bass Lines", description: "Create compelling bass lines on piano.", musical_benefits: ["Harmonic foundation", "Groove creation", "Self-sufficiency"], usps: ["Complete sound", "No bassist needed", "Band awareness"] }
    ]
  },
  {
    id: "theory-ear-training",
    name: "Theory & Ear Training",
    description: "Comprehensive musicianship training covering theory, ear training, and analysis.",
    classes: [
      { name: "Sight Singing", description: "Develop the ability to sing music at sight.", musical_benefits: ["Pitch accuracy", "Musical reading", "Inner hearing"], usps: ["Complete musician", "Audition ready", "Teaching tool"] },
      { name: "Rhythm Practice", description: "Master rhythm through beat divisions, phrasing, and syncopation.", musical_benefits: ["Rhythmic precision", "Groove feel", "Time awareness"], usps: ["Rock-solid time", "Any genre", "Band-ready"] },
      { name: "Harmony & Chord Application", description: "Understand harmonic theory and apply it in real situations.", musical_benefits: ["Harmonic understanding", "Composition ability", "Arrangement skills"], usps: ["Understand music deeply", "Create intelligently", "Communicate with musicians"] },
      { name: "Scales, Intervals and Modes", description: "Complete study of scales, intervals, and modes.", musical_benefits: ["Melodic fluency", "Modal awareness", "Improvisational tools"], usps: ["Unlimited melodic ideas", "Genre versatility", "Theoretical foundation"] },
      { name: "Ear Training", description: "Systematic ear training for intervals, scales, and chords.", musical_benefits: ["Ear development", "Transcription ability", "Musical intuition"], usps: ["Hear what you play", "Learn by ear", "Professional ear"] },
      { name: "Jazz Chord Charts & Analysis", description: "Learn to read jazz chord charts and analyze jazz harmony.", musical_benefits: ["Jazz literacy", "Analytical skills", "Performance preparation"], usps: ["Jam session ready", "Understand jazz", "Professional preparation"] }
    ]
  },
  {
    id: "seasonal-genre",
    name: "Seasonal & Genre Based",
    description: "Themed modules covering seasonal music and specific genres.",
    classes: [
      { name: "Christmas", description: "Learn beautiful Christmas music - carols and holiday favorites.", musical_benefits: ["Seasonal repertoire", "Arrangement skills", "Performance opportunities"], usps: ["Holiday gigs", "Family gatherings", "Worship leading"] },
      { name: "Trending Music", description: "Stay current with viral hits and trending songs.", musical_benefits: ["Relevance", "Quick learning", "Social connection"], usps: ["Social media ready", "Party favorite", "Stay relevant"] },
      { name: "Gospel", description: "Learn the art of gospel piano.", musical_benefits: ["Spiritual expression", "Rhythmic depth", "Worship skills"], usps: ["Church ministry", "Soul expression", "Community service"] },
      { name: "Bollywood", description: "Play Bollywood hits from classic gems to modern chartbusters.", musical_benefits: ["Cultural connection", "Melodic richness", "Party repertoire"], usps: ["Indian weddings", "Cultural events", "Popular repertoire"] },
      { name: "Coke Studio", description: "Learn the fusion magic of Coke Studio hits.", musical_benefits: ["Fusion skills", "Arrangement appreciation", "Unique repertoire"], usps: ["Unique sound", "Cultural bridge", "Artistic expression"] },
      { name: "Blues", description: "The foundation of popular music - authentic blues piano.", musical_benefits: ["Emotional expression", "Foundation skills", "Improvisational freedom"], usps: ["Essential foundation", "Emotional depth", "Jam session staple"] },
      { name: "Latin/Salsa", description: "Hot Latin rhythms - salsa, bossa nova, Latin jazz.", musical_benefits: ["Rhythmic independence", "Hand coordination", "Dance music skills"], usps: ["Dance parties", "Rhythmic mastery", "Latin authenticity"] },
      { name: "Regional Music", description: "Music from Indian regional traditions.", musical_benefits: ["Cultural roots", "Regional connection", "Diverse repertoire"], usps: ["Cultural preservation", "Family connection", "Regional events"] }
    ]
  },
  {
    id: "new-offerings",
    name: "New Offerings",
    description: "Exciting new programs focused on collaboration and real-world skills.",
    classes: [
      { name: "Educative Jam Sessions", description: "Learn through jamming - structured sessions with other musicians.", musical_benefits: ["Collaborative skills", "Real-time application", "Social musicianship"], usps: ["Learn by doing", "Make music friends", "Immediate application"] },
      { name: "Performance Workshops", description: "Workshops focused on specific concepts through group activities.", musical_benefits: ["Deep understanding", "Practical application", "Collaborative learning"], usps: ["Hands-on learning", "Community building", "Real musicianship"] },
      { name: "Working Musician Skills", description: "Practical skills for performing, recording, and teaching professionally.", musical_benefits: ["Career preparation", "Professional skills", "Multiple income streams"], usps: ["Career launch", "Real-world skills", "Income potential"] },
      { name: "Riff with Jason Zac", description: "Create riffs and compositions with guidance from Jason Zac.", musical_benefits: ["Compositional skills", "Creative development", "Professional feedback"], usps: ["Professional guidance", "Original music", "Artist development"] },
      { name: "Singing in Harmony", description: "Experience the joy of singing in harmony - choral sessions.", musical_benefits: ["Vocal development", "Ensemble awareness", "Harmonic appreciation"], usps: ["Community experience", "Vocal training", "Musical bonding"] }
    ]
  },
  {
    id: "foundation-lessons",
    name: "Foundation Lessons",
    description: "Core foundational courses for building fundamental musical skills.",
    classes: [
      { name: "Theory", description: "Comprehensive music theory from basics to advanced.", musical_benefits: ["Musical understanding", "Communication ability", "Analytical skills"], usps: ["Solid foundation", "Communication with musicians", "Teaching capability"] },
      { name: "Ear Training", description: "Systematic ear development for all musical elements.", musical_benefits: ["Ear development", "Transcription ability", "Musical intuition"], usps: ["Essential skill", "Independence from sheet music", "Professional ear"] },
      { name: "Rhythm Practice", description: "Master rhythm fundamentals to complex polyrhythms.", musical_benefits: ["Rhythmic accuracy", "Groove feel", "Time keeping"], usps: ["Foundation of all music", "Band-ready", "Groove master"] },
      { name: "Piano", description: "Core piano skills with proper technique and musicality.", musical_benefits: ["Keyboard proficiency", "Musical foundation", "Technical capability"], usps: ["Proper foundation", "No bad habits", "Efficient learning"] }
    ]
  }
];

const Bullet = ({ children }) => (
  <Text style={styles.bulletItem}><Text style={styles.bulletGold}>{'\u2022'} </Text>{children}</Text>
);

const ChecklistItem = ({ children }) => (
  <View style={styles.checklistItem}>
    <View style={styles.checkBox} />
    <Text style={styles.checkText}>{children}</Text>
  </View>
);

const PageFooter = ({ section }) => (
  <>
    <Text style={styles.pageFooter}>Nathaniel School of Music</Text>
    <Text style={styles.pageNumber}>{section}</Text>
  </>
);

const CoverPage = () => (
  <Page size="A4" style={styles.coverPage}>
    <View style={styles.coverBorder}>
      <Text style={styles.coverSchool}>NATHANIEL SCHOOL OF MUSIC</Text>
      <Text style={styles.coverTagline}>EXCELLENCE IN MUSICAL EDUCATION</Text>
      <View style={{ marginVertical: 40 }}>
        <View style={styles.coverLine} />
      </View>
      <Text style={styles.coverTitle}>Staff Training &{'\n'}Admissions Guide</Text>
      <Text style={styles.coverSubtitle}>A comprehensive resource for admin and communications staff</Text>
      <Text style={styles.coverFooter}>CONFIDENTIAL - FOR INTERNAL USE ONLY</Text>
    </View>
  </Page>
);

const Section1 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>1. The NSM Mission & Your Role</Text>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Our Mission</Text>
      <Text style={styles.paragraph}>
        Nathaniel School of Music (NSM) exists to transform passionate music lovers into confident, skilled musicians. Founded by Jason Zac, we believe that music education should be personalized, practical, and accessible to everyone regardless of their starting point.
      </Text>
      <Text style={styles.paragraph}>
        We don't follow a one-size-fits-all curriculum. Instead, we build custom learning packages tailored to each student's goals, experience level, and musical interests. Whether someone dreams of playing jazz at a club, leading worship at church, or simply playing their favorite songs at home, we create the path to get them there.
      </Text>
    </View>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Who Are Our Students?</Text>
      <Bullet>Complete beginners who've never touched a piano</Bullet>
      <Bullet>Self-taught players who want to fill in gaps and break bad habits</Bullet>
      <Bullet>Church musicians and worship leaders seeking deeper skills</Bullet>
      <Bullet>Working professionals who want music as a creative outlet</Bullet>
      <Bullet>Aspiring professional musicians building their career</Bullet>
      <Bullet>Returning students who took a break and want to restart</Bullet>
    </View>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Your Role</Text>
      <Text style={styles.paragraph}>
        As a communications staff member, you are the first human connection a prospective student has with NSM. Your job is not to "sell" but to understand, guide, and match. Every call is an opportunity to change someone's musical life.
      </Text>
      <Text style={styles.paragraph}>Your core responsibilities:</Text>
      <Bullet>Be the warm, knowledgeable first point of contact</Bullet>
      <Bullet>Understand each student's musical goals through active listening</Bullet>
      <Bullet>Map their goals to the right classrooms and classes</Bullet>
      <Bullet>Propose a tailored package that fits their time and budget</Bullet>
      <Bullet>Follow up professionally to guide them to enrollment</Bullet>
    </View>
    <PageFooter section="Section 1" />
  </Page>
);

const Section2 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>2. Student Types</Text>
    <Text style={styles.paragraph}>NSM serves three types of students, each entering through a different form. Understanding these types helps you tailor your approach.</Text>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>New Students</Text>
      <Text style={styles.paragraph}>Someone applying to NSM for the first time. They submit the New Student Application form.</Text>
      <Text style={{ ...styles.paragraph, fontFamily: 'Helvetica-Bold', color: colors.gold, fontSize: 9 }}>What the form captures:</Text>
      <Bullet>Personal details (name, email, phone, city, country)</Bullet>
      <Bullet>How they heard about NSM</Bullet>
      <Bullet>Piano experience level and years of playing</Bullet>
      <Bullet>Current piano usage (worship, personal, professional, etc.)</Bullet>
      <Bullet>Specific class interests from the full course catalog</Bullet>
      <Bullet>Preferred days and times for lessons</Bullet>
      <Bullet>Any additional notes or questions</Bullet>
    </View>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Existing Students</Text>
      <Text style={styles.paragraph}>Current students who want to adjust or rebuild their package. They use the Repackage form.</Text>
      <Text style={{ ...styles.paragraph, fontFamily: 'Helvetica-Bold', color: colors.gold, fontSize: 9 }}>What the form captures:</Text>
      <Bullet>Student identification (name, email)</Bullet>
      <Bullet>Updated class interests and scheduling preferences</Bullet>
      <Bullet>Reason for repackaging (expanding, narrowing, or shifting focus)</Bullet>
    </View>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Returning Students</Text>
      <Text style={styles.paragraph}>Former students who left and want to come back. They use the Returning Student form.</Text>
      <Text style={{ ...styles.paragraph, fontFamily: 'Helvetica-Bold', color: colors.gold, fontSize: 9 }}>What the form captures:</Text>
      <Bullet>Previous student details and reason for leaving</Bullet>
      <Bullet>Updated goals and interests</Bullet>
      <Bullet>Current skill level and what they remember</Bullet>
    </View>
    <PageFooter section="Section 2" />
  </Page>
);

const Section3 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>3. Admissions Status Workflow</Text>
    <Text style={styles.paragraph}>Every student moves through a defined pipeline. Here's each stage and what you do at each step.</Text>
    <View style={styles.statusBox}>
      <Text style={styles.statusTitle}>1. PENDING</Text>
      <Text style={styles.statusDesc}>A new application has been submitted. The student is waiting to hear from you. Action: Review their form, prepare for the initial call, and reach out within 24-48 hours.</Text>
    </View>
    <View style={styles.statusBox}>
      <Text style={styles.statusTitle}>2. CONTACTED</Text>
      <Text style={styles.statusDesc}>You've made the first call or message. You've introduced NSM and started understanding their goals. Action: Document call notes, schedule a follow-up if needed, begin mapping classes.</Text>
    </View>
    <View style={styles.statusBox}>
      <Text style={styles.statusTitle}>3. PACKAGE PROPOSED</Text>
      <Text style={styles.statusDesc}>You've discussed a recommended package with the student. They know which classrooms and classes you suggest, along with the hour count. Action: Finalize the package in the admin Package Builder tool.</Text>
    </View>
    <View style={styles.statusBox}>
      <Text style={styles.statusTitle}>4. PACKAGE SENT</Text>
      <Text style={styles.statusDesc}>The formal package has been created and sent to the student for review. They have a link to view their custom package. Action: Follow up within 3-5 days if no response. Be available for questions.</Text>
    </View>
    <View style={styles.statusBox}>
      <Text style={styles.statusTitle}>5. ENROLLED</Text>
      <Text style={styles.statusDesc}>The student has accepted the package and completed enrollment. They are now an active NSM student. Action: Welcome them, ensure they have access to all resources, introduce them to their schedule.</Text>
    </View>
    <View style={styles.statusBox}>
      <Text style={styles.statusTitle}>6. DECLINED</Text>
      <Text style={styles.statusDesc}>The student chose not to enroll at this time. Action: Thank them graciously, note the reason for declining, and keep the door open for the future. Set a 30-day follow-up reminder.</Text>
    </View>
    <PageFooter section="Section 3" />
  </Page>
);

const Section4Page1 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>4. The Phone Call Masterclass</Text>

    <Text style={styles.subsectionHeader}>Before the Call - Preparation Checklist</Text>
    <View style={styles.cardBox}>
      <ChecklistItem>Review the student's application form thoroughly</ChecklistItem>
      <ChecklistItem>Note their experience level (beginner / intermediate / advanced)</ChecklistItem>
      <ChecklistItem>Note their stated interests and class selections</ChecklistItem>
      <ChecklistItem>Check their preferred schedule (days and times)</ChecklistItem>
      <ChecklistItem>Have the classroom guide open for reference</ChecklistItem>
      <ChecklistItem>Prepare 2-3 classroom recommendations based on their form</ChecklistItem>
      <ChecklistItem>Have the Package Builder ready to create their package</ChecklistItem>
    </View>

    <Text style={styles.subsectionHeader}>Opening Scripts by Student Type</Text>
    <View style={styles.scriptBox}>
      <Text style={styles.scriptLabel}>New Student Opening</Text>
      <Text style={styles.scriptText}>"Hi [Name], this is [Your Name] from Nathaniel School of Music. Thank you so much for your application! I've gone through your form and I'm excited to chat about your musical journey. I see you're interested in [mention their stated interests]. I'd love to understand more about what you're hoping to achieve so we can build the perfect learning plan for you."</Text>
    </View>
    <View style={styles.scriptBox}>
      <Text style={styles.scriptLabel}>Existing Student (Repackage)</Text>
      <Text style={styles.scriptText}>"Hi [Name], thanks for reaching out about updating your package! I want to make sure your learning plan still matches where you are now and where you want to go. What's been working well in your current package, and what would you like to change?"</Text>
    </View>
    <View style={styles.scriptBox}>
      <Text style={styles.scriptLabel}>Returning Student</Text>
      <Text style={styles.scriptText}>"Hi [Name], welcome back! It's great to hear you want to get back into your music. I know taking a break can sometimes make it feel like starting over, but you'd be surprised how much comes back. Let's talk about where you are now and what you'd like to focus on this time around."</Text>
    </View>
    <PageFooter section="Section 4 - Page 1" />
  </Page>
);

const Section4Page2 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.subsectionHeader}>Discovery Questions</Text>
    <Text style={styles.paragraph}>These questions help you understand the student deeply. Don't rush through them - listen actively and take notes.</Text>

    <View style={styles.cardBox}>
      <Text style={{ ...styles.statusTitle, marginBottom: 6 }}>Goals & Motivation</Text>
      <Bullet>"What made you decide to start learning piano right now?"</Bullet>
      <Bullet>"If you could play one song perfectly six months from now, what would it be?"</Bullet>
      <Bullet>"Do you see music as a hobby, a potential career, or something in between?"</Bullet>
      <Bullet>"Is there a specific event or milestone you're working toward?"</Bullet>
    </View>
    <View style={styles.cardBox}>
      <Text style={{ ...styles.statusTitle, marginBottom: 6 }}>Current Level & Background</Text>
      <Bullet>"How long have you been playing? What's your comfort level right now?"</Bullet>
      <Bullet>"Can you read sheet music, or do you play by ear?"</Bullet>
      <Bullet>"What genres or styles do you gravitate toward?"</Bullet>
      <Bullet>"Have you had formal lessons before? What worked and what didn't?"</Bullet>
    </View>
    <View style={styles.cardBox}>
      <Text style={{ ...styles.statusTitle, marginBottom: 6 }}>Practical Considerations</Text>
      <Bullet>"How many hours per week can you realistically dedicate to learning?"</Bullet>
      <Bullet>"Do you have access to a piano or keyboard at home?"</Bullet>
      <Bullet>"Are you comfortable with online lessons, or do you prefer in-person?"</Bullet>
      <Bullet>"What's your ideal schedule for lessons?"</Bullet>
    </View>

    <Text style={styles.subsectionHeader}>Mapping Goals to Classrooms</Text>
    <Text style={styles.paragraph}>Based on the student's answers, start connecting their goals to specific classrooms:</Text>
    <View style={styles.cardBox}>
      <Bullet>"I want to play songs I hear" → Music Factory (Transcription, Lick Library)</Bullet>
      <Bullet>"I want proper technique" → Music Gym + Foundation Lessons</Bullet>
      <Bullet>"I want to play at church" → Music Factory (Church Hymns) + Modular Piano</Bullet>
      <Bullet>"I want to understand what I'm playing" → Theory & Ear Training</Bullet>
      <Bullet>"I want to play different styles" → Seasonal & Genre Based</Bullet>
      <Bullet>"I'm a complete beginner" → Foundation Lessons + Music Gym</Bullet>
      <Bullet>"I want to jam with others" → New Offerings (Jam Sessions, Workshops)</Bullet>
      <Bullet>"I want to sing and play" → Modular Piano (Sing & Play, Hand Independence)</Bullet>
    </View>
    <PageFooter section="Section 4 - Page 2" />
  </Page>
);

const Section4Page3 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.subsectionHeader}>How to Close the Call</Text>
    <View style={styles.cardBox}>
      <Text style={styles.paragraph}>After discussing classrooms and classes, transition to the package:</Text>
      <View style={styles.scriptBox}>
        <Text style={styles.scriptLabel}>Closing Script</Text>
        <Text style={styles.scriptText}>"Based on everything we've discussed, I think a [X]-hour package would be perfect for you. It would include [list 2-3 key classrooms] covering [their main goals]. I'm going to put together a custom package for you and send it over. You'll be able to see exactly which classes are included and how the hours are allocated. Does that sound good?"</Text>
      </View>
      <Text style={styles.paragraph}>Always end with clear next steps:</Text>
      <Bullet>Confirm their email address for the package link</Bullet>
      <Bullet>Set a specific timeline: "I'll have your package ready within 24 hours"</Bullet>
      <Bullet>Invite questions: "Feel free to reach out if anything comes to mind"</Bullet>
      <Bullet>Express genuine enthusiasm: "I'm really excited about the plan we've put together for you"</Bullet>
    </View>
    <PageFooter section="Section 4 - Page 3" />
  </Page>
);

const ClassroomPage = ({ classroom }) => {
  const lit = classroomLiterature[classroom.id];
  if (!lit) return null;

  return (
    <Page size="A4" style={styles.page} wrap>
      <Text style={styles.classroomHeader}>{classroom.name}</Text>
      <Text style={styles.classroomTagline}>"{lit.tagline}"</Text>
      <Text style={styles.paragraph}>{lit.overview}</Text>

      <View style={styles.twoCol}>
        <View style={styles.col}>
          <Text style={{ ...styles.statusTitle, marginBottom: 4, marginTop: 8 }}>Who Is This For?</Text>
          {lit.whoIsThisFor.map((item, i) => (
            <Bullet key={i}>{item}</Bullet>
          ))}
        </View>
        <View style={styles.col}>
          <Text style={{ ...styles.statusTitle, marginBottom: 4, marginTop: 8 }}>Key Benefits</Text>
          {lit.keyBenefits.map((item, i) => (
            <Bullet key={i}>{item}</Bullet>
          ))}
        </View>
      </View>

      <Text style={{ ...styles.statusTitle, marginTop: 12, marginBottom: 6 }}>Talking Points & Sales Scripts</Text>
      {lit.talkingPoints.map((point, i) => (
        <Text key={i} style={styles.talkingPoint}>{point}</Text>
      ))}

      <Text style={{ ...styles.statusTitle, marginTop: 12, marginBottom: 6 }}>Classes in This Classroom ({classroom.classes.length})</Text>
      {classroom.classes.map((cls, i) => (
        <View key={i} style={styles.classCard} wrap={false}>
          <Text style={styles.className}>{cls.name}</Text>
          <Text style={styles.classDesc}>{cls.description}</Text>
          <View style={styles.tagRow}>
            {cls.musical_benefits.map((b, j) => (
              <Text key={j} style={styles.tag}>{b}</Text>
            ))}
            {cls.usps.map((u, j) => (
              <Text key={`u-${j}`} style={{ ...styles.tag, backgroundColor: '#0a0a1a', borderColor: '#3a3a6a' }}>{u}</Text>
            ))}
          </View>
        </View>
      ))}
      <PageFooter section={`Section 5 - ${classroom.name}`} />
    </Page>
  );
};

const Section5Header = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>5. The 7 Classrooms</Text>
    <Text style={styles.paragraph}>
      NSM's curriculum is organized into 7 distinct classrooms, each serving a specific purpose in a student's musical development. Understanding these classrooms deeply is essential for recommending the right package.
    </Text>
    <Text style={styles.paragraph}>
      Each classroom section below includes: the classroom tagline, a detailed overview, who it's ideal for, key benefits, talking points for calls, and every class offered with descriptions, musical benefits, and unique selling points.
    </Text>
    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Quick Reference</Text>
      {classroomData.filter(c => c.id !== 'perks-tiers').map((cr, i) => (
        <View key={i} style={{ flexDirection: 'row', marginBottom: 4, alignItems: 'flex-start' }}>
          <Text style={{ ...styles.bulletGold, fontSize: 10, width: 150 }}>{cr.name}</Text>
          <Text style={{ fontSize: 9, color: colors.muted, flex: 1 }}>{cr.description}</Text>
        </View>
      ))}
    </View>
    <PageFooter section="Section 5 - Overview" />
  </Page>
);

const Section6 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>6. Building a Custom Package</Text>
    <Text style={styles.paragraph}>The Package Builder is your primary tool for creating personalized student packages. Here's how to use it effectively.</Text>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Step-by-Step Process</Text>
      <Bullet>Navigate to the student's record in the Admin Dashboard</Bullet>
      <Bullet>Click "Build Package" to open the Package Builder</Bullet>
      <Bullet>Select an hour package (24, 32, 40, 50, or 65 hours per semester)</Bullet>
      <Bullet>Allocate hours across classrooms based on the call discussion</Bullet>
      <Bullet>Add specific classes within each classroom</Bullet>
      <Bullet>Review the allocation to ensure it matches the student's priorities</Bullet>
      <Bullet>Save and send the package link to the student</Bullet>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Matching Hours to Goals</Text>
      <Text style={styles.paragraph}>Use these guidelines when deciding how many hours to allocate:</Text>
      <Bullet>Primary goal area: 40-50% of total hours</Bullet>
      <Bullet>Supporting skills: 25-35% of total hours</Bullet>
      <Bullet>Exploration/enrichment: 15-25% of total hours</Bullet>
      <Text style={{ ...styles.paragraph, marginTop: 8 }}>Example: A beginner who wants to play worship music with a 40-hour package:</Text>
      <Bullet>Foundation Lessons: 16 hours (40%) - build proper basics</Bullet>
      <Bullet>Music Factory (Church Hymns): 12 hours (30%) - worship specific</Bullet>
      <Bullet>Theory & Ear Training: 8 hours (20%) - musicianship</Bullet>
      <Bullet>Modular Piano (Sing & Play): 4 hours (10%) - accompaniment</Bullet>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Tips for Package Building</Text>
      <Bullet>Always include Foundation Lessons for beginners (minimum 20% of hours)</Bullet>
      <Bullet>Don't spread too thin - better to go deep in 3-4 classrooms than shallow in all 7</Bullet>
      <Bullet>Match the hour count to their available practice time</Bullet>
      <Bullet>Consider their budget - a smaller, focused package is better than an overwhelming one</Bullet>
      <Bullet>Leave room for Seasonal & Genre content if the student enjoys variety</Bullet>
    </View>
    <PageFooter section="Section 6" />
  </Page>
);

const Section7 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>7. Post-Call Checklist & Follow-Up</Text>
    <Text style={styles.paragraph}>After every call, complete these steps to ensure nothing falls through the cracks.</Text>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Immediately After the Call</Text>
      <ChecklistItem>Update the student's status in the Admin Dashboard</ChecklistItem>
      <ChecklistItem>Add detailed call notes (goals discussed, classrooms recommended, concerns raised)</ChecklistItem>
      <ChecklistItem>If ready, build the package in the Package Builder</ChecklistItem>
      <ChecklistItem>Update the student's preferred schedule if it changed during the call</ChecklistItem>
      <ChecklistItem>If the student requested a follow-up, schedule it immediately</ChecklistItem>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Sending the Package</Text>
      <ChecklistItem>Review the package one final time for accuracy</ChecklistItem>
      <ChecklistItem>Send the package link via email with a warm, personal message</ChecklistItem>
      <ChecklistItem>Update the status to "Package Sent"</ChecklistItem>
      <ChecklistItem>Set a 3-day follow-up reminder</ChecklistItem>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>Follow-Up Cadence</Text>
      <Bullet>Day 1: Send the package with a summary email</Bullet>
      <Bullet>Day 3: Light check-in - "Did you get a chance to review your package?"</Bullet>
      <Bullet>Day 7: Address any questions - "I wanted to see if you had any questions about the plan"</Bullet>
      <Bullet>Day 14: Final follow-up - "Just checking in one last time. We'd love to have you!"</Bullet>
      <Bullet>Day 30+: If declined, a gentle reconnect - "Thinking of you! Our door is always open"</Bullet>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.subsectionHeader}>What Makes a Great Follow-Up</Text>
      <Bullet>Reference something specific from your conversation</Bullet>
      <Bullet>Add value (share a relevant resource, tip, or encouragement)</Bullet>
      <Bullet>Be warm but not pushy - respect their decision timeline</Bullet>
      <Bullet>Always leave the door open, even if they say no</Bullet>
    </View>
    <PageFooter section="Section 7" />
  </Page>
);

const Section8 = () => (
  <Page size="A4" style={styles.page}>
    <Text style={styles.sectionHeader}>8. Common Objections & Responses</Text>
    <Text style={styles.paragraph}>Here are the most common objections you'll hear and how to handle them naturally.</Text>

    <View style={styles.cardBox}>
      <Text style={styles.objectionQ}>"It's too expensive."</Text>
      <Text style={styles.objectionA}>"I completely understand. Let me show you something - when you break it down by class, you're looking at [amount] per hour of instruction. That's significantly less than private lessons, and you're getting access to multiple classrooms and styles. We can also look at a smaller hour package to start - you can always upgrade later once you see the value."</Text>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.objectionQ}>"I don't have enough time."</Text>
      <Text style={styles.objectionA}>"That's actually one of the most common things we hear. The beauty of our system is flexibility. Many classes have recordings you can watch on your own schedule. Even 30 minutes a day, 3 times a week makes a real difference. We can build a package around your actual availability rather than asking you to change your schedule."</Text>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.objectionQ}>"I need to think about it."</Text>
      <Text style={styles.objectionA}>"Absolutely, take your time! I'll send you the package details so you have everything in writing. Is there anything specific you'd like to think through? Sometimes I can help clarify things that might make the decision easier. I'll follow up in a few days to see if any questions came up."</Text>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.objectionQ}>"I tried learning before and gave up."</Text>
      <Text style={styles.objectionA}>"You know what? Many of our best students say the same thing. The difference is usually in the approach. Traditional methods can be rigid and boring. At NSM, you learn what you actually want to play, at your pace. Plus, you have a whole team supporting you, not just one teacher."</Text>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.objectionQ}>"Can I try a class before committing?"</Text>
      <Text style={styles.objectionA}>"Great question! While we don't offer individual trial classes, the smallest package gives you a chance to experience multiple classrooms. Think of it as your trial - if it's not for you, there's no long-term commitment. Most students who start with us stay because they see results quickly."</Text>
    </View>

    <View style={styles.cardBox}>
      <Text style={styles.objectionQ}>"I'm too old to learn piano."</Text>
      <Text style={styles.objectionA}>"Not at all! We have students of all ages, and adult learners actually have advantages - better discipline, clearer goals, and more life experience to draw from musically. Some of our most dedicated students started in their 40s, 50s, and beyond."</Text>
    </View>
    <PageFooter section="Section 8" />
  </Page>
);

const TrainingGuidePDF = () => (
  <Document
    title="NSM Staff Training & Admissions Guide"
    author="Nathaniel School of Music"
    subject="Staff Training Guide"
  >
    <CoverPage />
    <Section1 />
    <Section2 />
    <Section3 />
    <Section4Page1 />
    <Section4Page2 />
    <Section4Page3 />
    <Section5Header />
    {classroomData.filter(c => c.id !== 'perks-tiers').map(classroom => (
      <ClassroomPage key={classroom.id} classroom={classroom} />
    ))}
    <Section6 />
    <Section7 />
    <Section8 />
  </Document>
);

export default TrainingGuidePDF;
